var render, staticRenderFns
import script from "./FocusOnKeyboardOnly.vue?vue&type=script&lang=js"
export * from "./FocusOnKeyboardOnly.vue?vue&type=script&lang=js"
import style0 from "./FocusOnKeyboardOnly.vue?vue&type=style&index=0&id=11ef27ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports